import { PackageCategory } from '@labsavvyapp/components'

export const generatePackageCategoryDropdownItems = (packageCategories: PackageCategory[]) => {
  if (!packageCategories?.length) {
    return []
  }
  const packageCategoriesDropdownItems = packageCategories.map((packageCategory: PackageCategory) => ({
    value: packageCategory._id,
    label: packageCategory.name,
  }))
  return packageCategoriesDropdownItems
}
